// halo-newsletter-popup.js (patched)
class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        // unique cookie name for the newsletter (prevents collisions with cookie-consent app)
        this.NEWSLETTER_COOKIE = 'vevyne_newsletter_popup_closed';

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');

        // Use the unique cookie name here
        if (this.getCookie(this.NEWSLETTER_COOKIE) === '') {
            var popup = this.popup;

            setTimeout(function() {
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700)
        } else {
            // this.deleteCookie(this.NEWSLETTER_COOKIE);
        }

        // listen for body clicks (closing when clicking outside) - handler below will ignore clicks from cookie widget
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        // close button inside newsletter — we will ensure only this sets the newsletter cookie
        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        // form submit also closes (existing behavior) — uses setClosePopup (which sets the unique cookie)
        this.querySelector('#ContactPopup')?.addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );

        this.dismissLabel = this.querySelector('label[for="dismiss"]');
        if (this.dismissLabel) {
            this.dismissLabel.addEventListener(
                'click',
                this.setClosePopup.bind(this)
            );
        }

        if(this.classList.contains('style-2')){
            this.copyButton = this.querySelector('.button-code--copy');
            if(this.copyButton){
                this.copyButton.addEventListener('click', () => {
                    this.inputField = this.querySelector('.code__input .field__input');
                    this.tooltip = this.copyButton.querySelector('.tooltip');
                    navigator.clipboard.writeText(this.inputField.value).then(() => {
                        this.tooltip.textContent =  this.tooltip.dataset.success_message;
                    });
                });
            }

            $('.halo-newsletter-popup.style-2 .products-grid:has(.product:nth-child(3))')?.slick({
                infinite: true,
                arrows: true,
                dots: false,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                slidesToShow: 2,
                slidesToScroll: 2,
                rtl: window.rtl_slick
            });
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }

    setClosePopup(event) {
        // set the unique newsletter cookie here, using the configured expiry
        this.setCookie(this.NEWSLETTER_COOKIE, 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);

        // stop propagation so other handlers don't treat this as a generic outside click
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
    }

    onBodyClickEvent(event){
        // If newsletter not visible, nothing to do
        if (!document.body.classList.contains('newsletter-show')) return;

        // If clicked inside the newsletter, do nothing
        if (this.contains(event.target)) return;

        // If click target is an explicit "open newsletter" trigger, do nothing
        if ($(event.target).closest('[data-open-newsletter-popup]').length > 0) return;

        // If click originated inside the GA:GDPR cookie widget (#goodg-app), avoid closing the newsletter.
        // We allow the cookie widget's own close button to operate normally (so the cookie banner can close).
        const clickedInsideGoodg = event.target && event.target.closest && event.target.closest('#goodg-app');
        const clickedGoodgCloseBtn = event.target && event.target.closest && event.target.closest('#goodg-app .goodg-cart__close');

        // If click is anywhere inside the cookie widget but NOT the cookie close button, ignore it
        if (clickedInsideGoodg && !clickedGoodgCloseBtn) {
            return;
        }

        // If click is the cookie widget close button, do NOT close the newsletter here.
        // This avoids the cookie banner close from accidentally hiding the newsletter.
        if (clickedGoodgCloseBtn) {
            return;
        }

        // Otherwise — click was outside newsletter and not part of cookie widget — close newsletter
        this.setClosePopup(event);
    }
}

customElements.define('newsletter-popup', NewsletterPopup);


class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);
